import { useCallback, useState } from 'react';
import type { PostingLogRow } from '@/utils/PostingLog/types';

export function usePostingLogSelection(rows: PostingLogRow[]) {
  const [selectedIds,      setSelectedIds]      = useState<Set<string>>(new Set());

  const handleToggleSelect = useCallback((id: string) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }, []);

  const handleToggleSelectAll = useCallback(() => {
    const failedIds = rows.filter((r) => r.status === 'Failed').map((r) => r.id);
    const allSel = failedIds.every((id) => selectedIds.has(id));
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (allSel) failedIds.forEach((id) => next.delete(id));
      else failedIds.forEach((id) => next.add(id));
      return next;
    });
  }, [rows, selectedIds]);

  const deselect = useCallback((rowId: string) => {
    setSelectedIds((prev) => { const next = new Set(prev); next.delete(rowId); return next; });
  }, []);

  return { selectedIds, handleToggleSelect, handleToggleSelectAll, deselect };
}
